import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithQuery, atomWithMutation } from 'jotai-tanstack-query';
import { workflowTemplateService } from '@/services';
import { invalidateQueries } from '@/lib/query-client';
import { buScopeParams } from '@/lib/business-unit-scope';

const workflowTemplatesQueryAtom = atomWithQuery(() => ({
	queryKey: ['workflow-templates'],
	queryFn: workflowTemplateService.getTemplates,
}));

const workflowTemplateByIdQueryAtom = (id: string) =>
	atomWithQuery(() => ({
		queryKey: ['workflow-templates', id],
		queryFn: () => workflowTemplateService.getTemplateById(id),
		enabled: !!id,
	}));

const useTemplateWorkflowMutationAtom = atomWithMutation((get) => ({
	mutationKey: ['workflow-templates', 'use'],
	mutationFn: ({ id, name }: { id: string; name?: string }) =>
		workflowTemplateService.useTemplate(id, name, buScopeParams(get)),
	onSuccess: () => {
		invalidateQueries(['workflows']);
	},
}));

export function useWorkflowTemplates() {
	const [query] = useAtom(workflowTemplatesQueryAtom);
	return query;
}

export function useWorkflowTemplateById(id: string) {
	const atom = useMemo(() => workflowTemplateByIdQueryAtom(id), [id]);
	const [query] = useAtom(atom);
	return query;
}

export function useUseTemplate() {
	const [mutation] = useAtom(useTemplateWorkflowMutationAtom);
	return mutation;
}
